import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ContractService } from "app/auth/service/contract.service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContractInfo } from "../../../../auth/models/contract";

interface CalculatedContract {
  level: string;
  salary_yearly_gross: number;
  total_yearly: number;
  total_month: number;
  net_monthly_12: number;
  net_monthly_13: number;
  total_net_monthly_13: number;
  total_daily: number;
  bonus: number;
}

@Component({
  selector: "app-simulation-costs",
  templateUrl: "./simulation-costs.component.html",
})
export class SimulationCostsComponent implements OnInit {
  public ral: string = "0,00";
  public bonus: string = "0,00";
  public calculatedContract: CalculatedContract;
  public selectedType: "indeterminate" | "apprenticeship" = "indeterminate";
  public indeterminateList: IContractInfo[] = [];
  public apprenticeshipList: IContractInfo[] = [];

  constructor(
    public _changeDetectorRef: ChangeDetectorRef,
    public _utilService: UtilsService,
    public _contractService: ContractService,
  ) {}

  async ngOnInit() {
    const contractList: any = await this._contractService.getCosts();
    if (!!contractList && contractList.length > 0) {
      this.indeterminateList = contractList.filter((item: any) => !item.is_apprendistato).sort((a: any, b: any) => (Number(b.salary_yearly_gross) < Number(a.salary_yearly_gross) ? 1 : -1));
      this.apprenticeshipList = contractList.filter((item: any) => item.is_apprendistato);
      this.apprenticeshipList = this.apprenticeshipList.sort((a: any, b: any) => (b.level > a.level ? 1 : -1));
    }
  }

  formatMoney(field: string) {
    if (field === "ral") {
      this.ral = this._utilService.addDotsToNumber(this.ral);
      if (this.ral === "0,00") {
        this.reset();
      }
    } else {
      this.bonus = this._utilService.addDotsToNumber(this.bonus);
    }
  }

  private transformInNumeric(cost) {
    return {
      ...cost,
      monthly_gross_12: Number(cost.monthly_gross_12),
      monthly_gross_13: Number(cost.monthly_gross_13),
      net_monthly_12: Number(cost.net_monthly_12),
      net_monthly_13: Number(cost.net_monthly_13),
      salary_yearly_gross: Number(cost.salary_yearly_gross),
      total_daily: Number(cost.total_daily),
      total_month: Number(cost.total_month),
      total_yearly: Number(cost.total_yearly),
    };
  }

  calculateCost() {
    this.calculatedContract = null;
    const ral: any = this._utilService.removeDotsFromNumber(this.ral);
    const bonus: number = this._utilService.removeDotsFromNumber(this.bonus);
    const isIndeterminate = this.selectedType === "indeterminate";

    const comparison_levels = isIndeterminate ? this.indeterminateList : this.apprenticeshipList;

    const max: any = this.transformInNumeric(comparison_levels[this.indeterminateList.length - 1]);
    const min: any = this.transformInNumeric(comparison_levels[0]);

    const contractsList: any[] = JSON.parse(JSON.stringify(comparison_levels)).map((cost) => this.transformInNumeric(cost));

    let contract: any;

    if (max.salary_yearly_gross <= ral) {
      this.calculatedContract = {
        level: max.level,
        salary_yearly_gross: ral,
        total_yearly: max.total_yearly,
        total_month: max.total_month,
        net_monthly_12: max.net_monthly_12,
        net_monthly_13: max.net_monthly_13,
        total_net_monthly_13: max.net_monthly_13,
        total_daily: max.total_daily,
        bonus,
      };
    } else if (Number(min.salary_yearly_gross) >= ral) {
      this.calculatedContract = {
        level: min.level,
        salary_yearly_gross: min.salary_yearly_gross,
        total_yearly: min.total_yearly,
        total_month: min.total_month,
        net_monthly_12: min.net_monthly_12,
        net_monthly_13: min.net_monthly_13,
        total_net_monthly_13: min.net_monthly_13,
        total_daily: min.total_daily,
        bonus,
      };
    } else {
      //Cerco quello che piú si avvicina tra tutti gli elementi tramite la differenza
      let founded: boolean = false;
      let levelA: any;
      let levelB: any;
      contractsList.map((cost: any, i: number) => {
        if (!founded && cost.salary_yearly_gross <= ral && contractsList[i + 1].salary_yearly_gross >= ral) {
          founded = true;
          levelA = cost;
          levelB = contractsList[i + 1];
        }
      });

      const theshold: number = levelA.salary_yearly_gross + (levelB.salary_yearly_gross - levelA.salary_yearly_gross) / 2;
      contract = ral > theshold ? levelB : levelA;
      
      this.calculatedContract = {
        level: ral < theshold ? levelB.level : levelA.level,
        salary_yearly_gross: ral,
        total_yearly: (contract.total_yearly * ral) / contract.salary_yearly_gross,
        total_month: (contract.total_month * ral) / contract.salary_yearly_gross,
        net_monthly_12: (contract.net_monthly_12 * ral) / contract.salary_yearly_gross,
        net_monthly_13: (contract.net_monthly_13 * ral) / contract.salary_yearly_gross,
        total_net_monthly_13: (contract.total_net_monthly_13 * ral) / contract.salary_yearly_gross,
        total_daily: (contract.total_daily * ral) / contract.salary_yearly_gross,
        bonus,
      };
    }

    if (this.calculatedContract.bonus > 0) {
      this.calculatedContract.total_yearly += this.calculatedContract.bonus * 12;
      this.calculatedContract.total_net_monthly_13 += this.calculatedContract.bonus;
      this.calculatedContract.total_daily += this.calculatedContract.bonus / 20;
    }
  }

  reset() {
    this.calculatedContract = null;
    this.ral = "0,00";
    this.bonus = "0,00";
    this.selectedType = "indeterminate";
  }
}
